import React, { FC, useEffect, useRef, useState } from 'react'
import { Platform, StyleSheet, TextInput, View } from 'react-native'
import { theme } from '@linqpal/common-frontend'
import { IconSearch } from '../../assets/icons'
import Color from 'color'

interface ISearchBarProps {
  placeholder: string
  value: string
  testID?: string
  onChange: (value: string) => void
  magnifierPosition?: 'left' | 'right'
}

export const SearchBar: FC<ISearchBarProps> = ({
  placeholder,
  value,
  testID = 'search_input_table',
  onChange,
  magnifierPosition = 'left',
}) => {
  const [searchText, setSearchText] = useState(value)

  const isMounted = useRef(false)

  useEffect(() => {
    if (isMounted.current) {
      const timeoutId = setTimeout(() => onChange(searchText), 900)

      return () => clearTimeout(timeoutId)
    } else {
      isMounted.current = true
      return
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText])

  return (
    <View style={styles.wrapper} testID={`${testID}_wrapper`}>
      {magnifierPosition === 'left' && (
        <View style={styles.iconLeft}>
          <IconSearch width={21} height={21} />
        </View>
      )}
      <TextInput
        value={searchText}
        onChangeText={setSearchText}
        placeholder={placeholder}
        placeholderTextColor={Color(theme.light.colors.primary)
          .alpha(0.4)
          .rgb()
          .string()}
        style={styles.input}
        testID={testID}
      />

      {magnifierPosition === 'right' && (
        <View style={styles.iconRight}>
          <IconSearch width={21} height={21} />
        </View>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    borderWidth: 1,
    borderColor: theme.light.colors.borderLight,
    borderRadius: 4,
    padding: 11,
    flexDirection: 'row',
    flex: 1,
    marginRight: 24,
    backgroundColor: '#F7F9FC',
  },
  iconLeft: {
    marginRight: 8,
  },
  iconRight: {
    marginRight: 8,
  },
  input: {
    color: theme.light.colors.primary,
    fontSize: 16,
    lineHeight: 1.5,
    fontWeight: '400',
    flex: 1,
    overflow: 'hidden',
    ...Platform.select({ web: { outline: 'none' } }),
  },
})
